module.exports = __webpack_public_path__ + "img/Collapse.700e1175.svg";